import APPLICATIONS from '../../contracts/enums/ItpRegex';
import ERT_CODES from '../../contracts/enums/ErtCodes';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { CB_VERSION_TYPE_SELECT_FILTERS } from '../../contracts/enums/CbVersionType';
import { nsContract, nsSearchContract } from '@/app/i18n/namespaces';

export default {
    UUID: {
        key: 'uuid'
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    PROVIDER: {
        key: 'provider',
        LEGAL_NAME: {
            parentKeys: ['provider'],
            key: 'legalName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.legal_name',
            namespace: ''
        }
    },
    APPLICATION: {
        key: 'application',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.application',
        namespace: nsContract,
        filter: 'select',
        placeholder: 'filter.placeholder.application',
        enableSorting: true,
        enum: APPLICATIONS,
        sortOptions: true
    },
    NUMBER: {
        key: 'number',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.contract_number',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.contract',
        enableSorting: true
    },
    RANK: {
        key: 'rank',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.rank',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.rank',
        enableSorting: true
    },
    LABEL: {
        key: 'label',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.label',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.label',
        enableSorting: true
    },
    BANK_CODE: {
        key: 'bankCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.bank_code',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.bank_code',
        enableSorting: true
    },
    X25_ADDRESS: {
        key: 'x25Address',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.x25_address',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.x25_address',
        enableSorting: true
    },
    ITP: {
        key: 'itp',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.itp',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.itp',
        enableSorting: true
    },
    CB_VERSION: {
        key: 'cbVersion',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.cb_version',
        namespace: nsContract,
        filter: 'select',
        placeholder: 'filter.placeholder.cb_version',
        enum: CB_VERSION_TYPE_SELECT_FILTERS,
        enableSorting: true
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.registration_number',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.registration_number',
        enableSorting: true
    },
    LEGAL_BUSINESS_NAME: {
        key: 'legalAndBusinessName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.legal_and_business_name',
        namespace: nsSearchContract,
        filter: 'input',
        placeholder: 'filter.placeholder.legal_and_business_name',
        enableSorting: true,
        tooltip: 'tooltip.legal_and_business_name'
    },
    LAST_SOURCE_IP: {
        key: 'lastSourceIp',
        type: FIELD_TYPES.TEXT,
        entity: 'merchantContract_last_source_ip'
    },
    LAST_ICCID: {
        key: 'lastIccid',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.last_iccid',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.last_iccid',
        enableSorting: true
    },
    LAST_ICCID_OPERATOR: {
        key: 'lastIccidOperator',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.last_iccid_operator',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.last_iccid_operator',
        enableSorting: true
    },
    LAST_CONNECTION_TYPE: {
        key: 'lastConnectionType',
        type: FIELD_TYPES.TEXT,
        prefix: 'merchantContract_connection_type_',
        entity: 'merchantContract_last_connection_type'
    },
    LAST_REMOTE_COLLECTION_DATE: {
        key: 'lastRemoteCollectionDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.last_remote_collection_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.last_remote_collection_date',
        enableSorting: true
    },
    LAST_CONNECTION_DATE: {
        key: 'lastConnectionDate',
        type: FIELD_TYPES.TEXT,
        entity: 'merchantContract_last_connection_date'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.created_at',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.created_at',
        enableSorting: true
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'merchantContract_updated_at'
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        UUID: {
            parentKeys: ['posTerminal'],
            key: 'uuid'
        },
        SERIAL_NUMBER: {
            parentKeys: ['posTerminal'],
            type: FIELD_TYPES.TEXT,
            key: 'serialNumber',
            entity: 'keys.serial_number',
            namespace: nsContract,
            filter: 'input',
            placeholder: 'filter.placeholder.serial_number',
            helpText: (values = {}, props) => {
                const manufacturer = getSelectedManufacturerInForm(values.manufacturer, props.manufacturersList);

                return manufacturer ? `posTerminal_help_${manufacturer.value}` : undefined;
            },
            enableSorting: true,
            isNested: true
        },
        MANUFACTURER: {
            parentKeys: ['posTerminal'],
            key: 'manufacturer',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.manufacturer',
            namespace: nsContract,
            filter: 'input',
            placeholder: 'filter.placeholder.manufacturer',
            enableSorting: true,
            isNested: true
        }
    },
    POS_TERMINAL_SUBSCRIPTION: {
        key: 'posTerminalSubscription',
        type: FIELD_TYPES.TEXT,
        entity: 'posTerminal_subscription'
    },
    LAST_SSL_VERSION: {
        key: 'lastSslVersion',
        type: 'select',
        entity: 'posTerminal_last_ssl_version'
    },
    MODEL: {
        key: 'model',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.model',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.model',
        enableSorting: true
    },
    SPECIFICATION: {
        key: 'specification',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.specification',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.specification',
        enableSorting: true
    },
    BULLETINS: {
        key: 'appliedBulletins',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.bulletins',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.bulletins',
        enableSorting: true
    },
    ERT_CODE: {
        key: 'ertCode',
        type: 'select',
        entity: 'keys.ert_code',
        namespace: nsContract,
        filter: 'select',
        placeholder: 'filter.placeholder.ert_code',
        enableSorting: true,
        enum: ERT_CODES
    },
    CB_AGREEMENT_NUMBER: {
        key: 'cbApproval',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.cb_approval',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.cb_approval',
        enableSorting: true
    },
    CB_AGREEMENT_DATE: {
        key: 'cbApprovalDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.cb_approval_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.cb_approval_date',
        enableSorting: true
    },
    PCI_VERSION: {
        key: 'pciVersion',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.pci_version',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.pci_version',
        enableSorting: true
    },
    PCI_EXPIRATION_DATE: {
        key: 'pciExpirationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.pci_expiration_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.pci_expiration_date',
        enableSorting: true
    },
    PCI_PP_VERSION: {
        key: 'pciPp16Version',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.pci_pp_version',
        namespace: nsContract,
        filter: 'input',
        placeholder: 'filter.placeholder.pci_pp_version',
        enableSorting: true
    },
    PCI_PP_EXPIRATION_DATE: {
        key: 'pciPpExpirationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.pci_pp_expiration_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.pci_pp_expiration_date',
        enableSorting: true
    },
    END_OF_USE_DATE: {
        key: 'endOfUseDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.end_of_use_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.end_of_use_date',
        enableSorting: true
    },
    EXPIRATION_DATE: {
        key: 'expirationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.expiration_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.expiration_date',
        enableSorting: true
    },
    END_OF_DEPLOYMENT_DATE: {
        key: 'endOfDeploymentDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.end_of_deployment_date',
        namespace: nsContract,
        filter: 'date',
        placeholder: 'filter.placeholder.end_of_deployment_date',
        enableSorting: true
    }
};